// Wraps trackEvent with automatic global context params (user_role, locale, is_mobile).
// Use this hook in all components. Use raw trackEvent() in non-React contexts
// (axiosInterceptor.ts) where DentobookApplicationContext is unavailable.
import { useContext } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { DentobookApplicationContext } from '../context/DentobookApplicationContext';
import { trackEvent } from '../utils/analytics';

type EventParams = Record<string, string | number | boolean | string[] | undefined>;

export const useTrackEvent = () => {
    const { principal, locale } = useContext(DentobookApplicationContext);

    return (eventName: string, params: EventParams = {}) => {
        trackEvent(eventName, {
            user_role: principal?.user?.role ?? 'unknown',
            locale: locale ?? 'unknown',
            is_mobile: isMobileOnly,
            ...params,
        });
    };
};
